import Head from 'next/head';
import {ThemeProvider} from 'styled-components';

import theme from 'utils/theme';
import GlobalStyles from 'utils/globalStyles';

function MyApp({Component, pageProps}) {
  return (
    <ThemeProvider theme={theme}>
      <Head>
        <link href={`${(process.env.NEXT_PUBLIC_BASE_URL ? process.env.NEXT_PUBLIC_BASE_URL : 'http://localhost:3000')}/favicon-32x32.png`} rel="shortcut icon" type="image/x-icon" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <GlobalStyles />
      <Component {...pageProps} />
    </ThemeProvider>
  );
}

export default MyApp;
